<template>
    <div>
        <div v-if="extra.old">
            <span class="timeline-key">Amount </span> : {{cost}} <br>
            <span class="timeline-key">Invoice number </span> : {{extra.invoice_number}} <br>
        </div>
        <div v-else>
            <span v-if="extra.source && extra.source.toLowerCase() === 'online'">
                                <span class="timeline-key">Source </span>: Online Card Payment <br>
                                <span
                                    class="timeline-key">Amount </span> : {{extra.transaction_detail.amount}} USD  <br>
                                <span class="timeline-key">Trasaction ID: </span> : {{extra.transaction_detail.ipay_out__ipg_txn_id}}   <br>
                                <span class="timeline-key">Merchant Reference ID: </span> : {{extra.transaction_detail.ipay_out__mer_ref_id}}   <br>

            </span>
            <span v-else>
                <span class="timeline-key">Source </span> : <b>{{extra.source}}</b><br>
                          <span class="timeline-key">Amount </span> : {{cost}} USD  <br>
                          <span v-if="extra.manual">
                                <span class="timeline-key">Bank </span> : {{extra.bank}} <br>
                                <span class="timeline-key">Invoice number :</span> {{extra.invoice_number}} <br>
                                <div v-if="extra.late_stay_cost>0">   <span class="timeline-key">Late stay cost :</span> {{extra.late_stay_cost}} USD </div>
                                <div v-if="extra.penalty>0">  <span class="timeline-key" v-if="extra.penalty>0">Penalty :</span> {{extra.penalty}} USD </div>
                            </span>
                            <span v-else>
                                <span class="timeline-key">Amount(NPR) </span> : {{extra.voucher_detail.data.totalAmount}}  <br>
                                <span class="timeline-key">Bank </span> : {{extra.voucher_detail.data.collectedBank.bankEDesc}} <br>
                               <div v-if="extra.late_stay_cost>0"> <span class="timeline-key">Late stay cost :</span> {{extra.late_stay_cost}} USD</div>
                                <div v-if="extra.late_stay_cost>0"> <span
                                    class="timeline-key">Penalty :</span> {{extra.penalty}} USD </div>
                            </span>
        <file-display :src="extra.image" v-if="extra.image"/>
            </span>

        </div>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";
    export default {
        name: "Paid",
        components: {FileDisplay},
        props: ['extra', 'days', 'cost', 'user'],
    }
</script>
